// Promotional tags for menu items (one per item). Keep in sync with
// backend/utils/itemTags.js — the backend rejects anything else.
export const ITEM_TAGS = [
    'Buy 1 Get 1 Free',
    'Combo Deal',
    "Today's Deal",
    'Best Seller 🔥',
    'Top Selling',
    'Weekend Special',
    'Midnight Deal',
    'Party Pack',
    'Couple Combo',
];

// Badge colours per tag (Tailwind classes).
export const ITEM_TAG_STYLES = {
    'Buy 1 Get 1 Free': 'bg-pink-100 text-pink-800',
    'Combo Deal': 'bg-indigo-100 text-indigo-800',
    "Today's Deal": 'bg-orange-100 text-orange-800',
    'Best Seller 🔥': 'bg-red-100 text-red-800',
    'Top Selling': 'bg-amber-100 text-amber-800',
    'Weekend Special': 'bg-purple-100 text-purple-800',
    'Midnight Deal': 'bg-slate-800 text-white',
    'Party Pack': 'bg-yellow-100 text-yellow-800',
    'Couple Combo': 'bg-rose-100 text-rose-800',
};
